const env = process.env.NODE_ENV
// var url = 'http://com.aojv.cj:19091/interview';
// var url = 'http://192.168.2.75:19091/interview'; 
var url = 'https://train.aojuai.com/interview';
// 新服务
// var url2 = 'http://192.168.2.75:19091/ajdataother'; 
var url2 = 'https://train.aojuai.com/ajdataother'; //线上
var url3 = 'https://assetsuse.aojuai.com'; //人事行政
// var url3 = 'http://com.aojv.cj:16066'; //人事行政-本地
const config = {
  development:{
    // baseURL :url//本地
    baseURL :url, //线上 
    baseURL2 :url2, //线上 
    baseURL3 :url3 //线上 
  },
  production:{
     baseURL :'https://train.aojuai.com/interview',
     baseURL2 :'https://train.aojuai.com/ajdataother',
     baseURL3:'https://assetsuse.aojuai.com',
  }
}
export default {  
  baseURL:config[env].baseURL,
  baseURL2:config[env].baseURL2,
  baseURL3:config[env].baseURL3,
}